/**
 * 2026 World Cup squads (source: football-data.org), powering the player-card
 * collectible game. Static reference data — each entry is
 * [football-data player id, name, position, nation team code].
 */
export type WcPlayerPos = 'GK' | 'DEF' | 'MID' | 'FWD';

export interface WcSquadPlayer {
  /** football-data player id (stable key). */
  id: number;
  name: string;
  pos: WcPlayerPos;
  /** Nation team code (matches our WcTeam ids / FIFA_RANKS keys). */
  nat: string;
}

const RAW: ReadonlyArray<readonly [number, string, WcPlayerPos, string]> = [
  [3160, 'Fernando Muslera', 'GK', 'URU'],
  [30210, 'Santiago Mele', 'GK', 'URU'],
  [30386, 'Sergio Rochet', 'GK', 'URU'],
  [3165, 'Guillermo Varela', 'DEF', 'URU'],
  [28292, 'Ronald Araújo', 'DEF', 'URU'],
  [28326, 'Sebastían Cáceres', 'DEF', 'URU'],
  [28426, 'Matías Viña', 'DEF', 'URU'],
  [28740, 'Joaquín Piquerez', 'DEF', 'URU'],
  [28770, 'Maximiliano Araújo', 'DEF', 'URU'],
  [32754, 'Mathías Olivera', 'DEF', 'URU'],
  [32767, 'Santiago Bueno', 'DEF', 'URU'],
  [213277, 'José Giménez', 'DEF', 'URU'],
  [96, 'Federico Valverde', 'MID', 'URU'],
  [1244, 'Giorgian De Arrascaeta', 'MID', 'URU'],
  [2041, 'Rodrigo Bentancur', 'MID', 'URU'],
  [28549, 'Manuel Ugarte', 'MID', 'URU'],
  [28618, 'Brian Rodríguez', 'MID', 'URU'],
  [121007, 'Rodrigo Zalazar', 'MID', 'URU'],
  [122506, 'Facundo Pellistri', 'MID', 'URU'],
  [130957, 'Emiliano Martínez', 'MID', 'URU'],
  [152435, 'Juan Sanabria', 'MID', 'URU'],
  [168795, 'Nicolas de la Cruz', 'MID', 'URU'],
  [11206, 'Rodrigo Aguirre', 'FWD', 'URU'],
  [28612, 'Darwin Núñez', 'FWD', 'URU'],
  [28614, 'Agustín Canobbio', 'FWD', 'URU'],
  [112678, 'Federico Viñas', 'FWD', 'URU'],
  [316, 'Oliver Baumann', 'GK', 'GER'],
  [341, 'Manuel Neuer', 'GK', 'GER'],
  [6491, 'Alexander Nübel', 'GK', 'GER'],
  [149, 'Jonathan Tah', 'DEF', 'GER'],
  [379, 'Waldemar Anton', 'DEF', 'GER'],
  [3177, 'Antonio Rüdiger', 'DEF', 'GER'],
  [9905, 'David Raum', 'DEF', 'GER'],
  [75539, 'Nico Schlotterbeck', 'DEF', 'GER'],
  [142732, 'Malick Thiaw', 'DEF', 'GER'],
  [184533, 'Nathaniel Brown', 'DEF', 'GER'],
  [320, 'Nadiem Amiri', 'MID', 'GER'],
  [359, 'Joshua Kimmich', 'MID', 'GER'],
  [3181, 'Leon Goretzka', 'MID', 'GER'],
  [8273, 'Pascal Groß', 'MID', 'GER'],
  [19334, 'Florian Wirtz', 'MID', 'GER'],
  [101074, 'Felix Kalu Nmecha', 'MID', 'GER'],
  [128565, 'Angelo Stiller', 'MID', 'GER'],
  [144393, 'Jamal Musiala', 'MID', 'GER'],
  [202665, 'Aleksandar Pavlović', 'MID', 'GER'],
  [212636, 'Assan Ouédraogo', 'MID', 'GER'],
  [171, 'Kai Havertz', 'FWD', 'GER'],
  [3184, 'Leroy Sané', 'FWD', 'GER'],
  [6928, 'Deniz Undav', 'FWD', 'GER'],
  [123333, 'Jamie Leweling', 'FWD', 'GER'],
  [133547, 'Nick Woltemade', 'FWD', 'GER'],
  [133903, 'Maximilian Beier', 'FWD', 'GER'],
  [4832, 'David Raya', 'GK', 'ESP'],
  [32570, 'Unai Simón', 'GK', 'ESP'],
  [152506, 'Joan García', 'GK', 'ESP'],
  [7884, 'Aymeric Laporte', 'DEF', 'ESP'],
  [15863, 'Cucurella', 'DEF', 'ESP'],
  [16739, 'Alejandro Grimaldo', 'DEF', 'ESP'],
  [81037, 'Pedro Porro', 'DEF', 'ESP'],
  [101345, 'Eric García', 'DEF', 'ESP'],
  [176745, 'Marc Pubill', 'DEF', 'ESP'],
  [217540, 'Pau Cubarsí', 'DEF', 'ESP'],
  [22, 'Fabián Ruiz', 'MID', 'ESP'],
  [70, 'Marcos Llorente', 'MID', 'ESP'],
  [3199, 'Rodri', 'MID', 'ESP'],
  [7935, 'Mikel Merino', 'MID', 'ESP'],
  [23132, 'Dani Olmo', 'MID', 'ESP'],
  [33154, 'Ferrán Torres', 'MID', 'ESP'],
  [115035, 'Martín Zubimendi', 'MID', 'ESP'],
  [133860, 'Pedri', 'MID', 'ESP'],
  [171992, 'Pablo Gavira', 'MID', 'ESP'],
  [180137, 'Mikel Oyarzabal', 'MID', 'ESP'],
  [213278, 'Álex Baena', 'MID', 'ESP'],
  [32056, 'Borja Iglesias', 'FWD', 'ESP'],
  [152505, 'Yeremi Pino', 'FWD', 'ESP'],
  [157135, 'Nico Williams', 'FWD', 'ESP'],
  [202283, 'Lamine Yamal', 'FWD', 'ESP'],
  [273423, 'Víctor Muñoz', 'FWD', 'ESP'],
  [28294, 'Gastón Olveira', 'GK', 'PAR'],
  [169622, 'Roberto Fernández', 'GK', 'PAR'],
  [270728, 'Orlando Gill', 'GK', 'PAR'],
  [1436, 'Fabián Balbuena', 'DEF', 'PAR'],
  [1741, 'Gustavo Gómez', 'DEF', 'PAR'],
  [8395, 'Júnior Alonso', 'DEF', 'PAR'],
  [46491, 'Omar Alderete', 'DEF', 'PAR'],
  [141752, 'Juan Cáceres', 'DEF', 'PAR'],
  [172169, 'Gustavo Velázquez', 'DEF', 'PAR'],
  [178832, 'José Canale', 'DEF', 'PAR'],
  [274608, 'Alexandro Maidana', 'DEF', 'PAR'],
  [46467, 'Andrés Cubas', 'MID', 'PAR'],
  [57316, 'Kaku', 'MID', 'PAR'],
  [76861, 'Miguel Almirón', 'MID', 'PAR'],
  [119594, 'Mauricio', 'MID', 'PAR'],
  [122397, 'Braian Ojeda', 'MID', 'PAR'],
  [165622, 'Matías Galarza', 'MID', 'PAR'],
  [168954, 'Damian Bobadilla', 'MID', 'PAR'],
  [178951, 'Diego Gómez', 'MID', 'PAR'],
  [14, 'Antonio Sanabria', 'FWD', 'PAR'],
  [59693, 'Gabriel Ávalos', 'FWD', 'PAR'],
  [114353, 'Isidro Pitta', 'FWD', 'PAR'],
  [140647, 'Ramón Sosa', 'FWD', 'PAR'],
  [168949, 'Julio Enciso', 'FWD', 'PAR'],
  [191772, 'Gustavo Caballero', 'FWD', 'PAR'],
  [250206, 'Alex Arce', 'FWD', 'PAR'],
  [6, 'Géronimo Rulli', 'GK', 'ARG'],
  [3141, 'Emiliano Martínez', 'GK', 'ARG'],
  [46554, 'Juan Musso', 'GK', 'ARG'],
  [3205, 'Nicolás Otamendi', 'DEF', 'ARG'],
  [3208, 'Nicolás Tagliafico', 'DEF', 'ARG'],
  [11667, 'Gonzalo Montiel', 'DEF', 'ARG'],
  [45735, 'Christian Romero', 'DEF', 'ARG'],
  [46125, 'Facundo Medina', 'DEF', 'ARG'],
  [46451, 'Lisandro Martínez', 'DEF', 'ARG'],
  [46452, 'Nahuel Molina', 'DEF', 'ARG'],
  [82020, 'Leonardo Balerdi', 'DEF', 'ARG'],
  [170261, 'Valentin Barco', 'DEF', 'ARG'],
  [2127, 'Rodrigo de Paul', 'MID', 'ARG'],
  [3214, 'Leandro Paredes', 'MID', 'ARG'],
  [3216, 'Giovani Lo Celso', 'MID', 'ARG'],
  [11720, 'Exequiel Palacios', 'MID', 'ARG'],
  [45681, 'Alexis Mac Allister', 'MID', 'ARG'],
  [79953, 'Thiago Almada', 'MID', 'ARG'],
  [102603, 'Enzo Fernández', 'MID', 'ARG'],
  [203511, 'Nico Paz', 'MID', 'ARG'],
  [3218, 'Lionel Messi', 'FWD', 'ARG'],
  [3220, 'Lautaro Martínez', 'FWD', 'ARG'],
  [45680, 'Nicolás González', 'FWD', 'ARG'],
  [98571, 'Julián Álvarez', 'FWD', 'ARG'],
  [170698, 'José Manuel López', 'FWD', 'ARG'],
  [171964, 'Giuliano Simeone', 'FWD', 'ARG'],
  [495, 'Lawrence Ati-Zigi', 'GK', 'GHA'],
  [137390, 'Joseph Anang', 'GK', 'GHA'],
  [277336, 'Benjamin Asare', 'GK', 'GHA'],
  [6499, 'Abdul Rahman Baba', 'DEF', 'GHA'],
  [7442, 'Derrick Luckassen', 'DEF', 'GHA'],
  [16340, 'Gideon Mensah', 'DEF', 'GHA'],
  [25641, 'Abdul Mumin', 'DEF', 'GHA'],
  [128235, 'Jerome Opoku', 'DEF', 'GHA'],
  [147893, 'Alidu Seidu', 'DEF', 'GHA'],
  [153924, 'Marvin Senaya', 'DEF', 'GHA'],
  [191269, 'Jonas Adjei Adjetey', 'DEF', 'GHA'],
  [202896, 'Kojo Peprah Oppong', 'DEF', 'GHA'],
  [110, 'Thomas Partey', 'MID', 'GHA'],
  [8470, 'Elisha Owusu', 'MID', 'GHA'],
  [79960, 'Kwasi Sibo', 'MID', 'GHA'],
  [175747, 'Augustine Boakye', 'MID', 'GHA'],
  [262187, 'Caleb Yirenkyi', 'MID', 'GHA'],
  [4417, 'Antoine Semenyo', 'FWD', 'GHA'],
  [6389, 'Brandon Thomas-Asante', 'FWD', 'GHA'],
  [7984, 'Jordan Ayew', 'FWD', 'GHA'],
  [32629, 'Iñaki Williams', 'FWD', 'GHA'],
  [142140, 'Kamal Deen Sulemana', 'FWD', 'GHA'],
  [184726, 'Ernest Nuamah', 'FWD', 'GHA'],
  [187162, 'Abdul Issahaku', 'FWD', 'GHA'],
  [193596, 'Christopher Bonsu Baah', 'FWD', 'GHA'],
  [218805, 'Prince Adu', 'FWD', 'GHA'],
  [1170, 'Weverton', 'GK', 'BRA'],
  [1795, 'Alisson Becker', 'GK', 'BRA'],
  [3222, 'Ederson', 'GK', 'BRA'],
  [1081, 'Roger Ibañez', 'DEF', 'BRA'],
  [1106, 'Bremer', 'DEF', 'BRA'],
  [2028, 'Alex Sandro', 'DEF', 'BRA'],
  [3225, 'Marquinhos', 'DEF', 'BRA'],
  [6517, 'Douglas Santos', 'DEF', 'BRA'],
  [7881, 'Danilo Luiz da Silva', 'DEF', 'BRA'],
  [11192, 'Léo Pereira', 'DEF', 'BRA'],
  [23128, 'Gabriel Magalhães', 'DEF', 'BRA'],
  [179164, 'Wesley', 'DEF', 'BRA'],
  [1543, 'Lucas Paquetá', 'MID', 'BRA'],
  [1684, 'Bruno Guimarães', 'MID', 'BRA'],
  [3231, 'Casemiro', 'MID', 'BRA'],
  [8749, 'Fabinho', 'MID', 'BRA'],
  [149704, 'Danilo dos Santos de Oliveira', 'MID', 'BRA'],
  [1556, 'Vinicius Junior', 'FWD', 'BRA'],
  [8491, 'Neymar', 'FWD', 'BRA'],
  [30842, 'Matheus Cunha', 'FWD', 'BRA'],
  [37428, 'Raphinha', 'FWD', 'BRA'],
  [61450, 'Martinelli', 'FWD', 'BRA'],
  [138230, 'Thiago', 'FWD', 'BRA'],
  [145539, 'Luiz Henrique', 'FWD', 'BRA'],
  [188487, 'Endrick', 'FWD', 'BRA'],
  [203356, 'Rayan', 'FWD', 'BRA'],
  [15899, 'José Sá', 'GK', 'POR'],
  [32014, 'Rui Silva', 'GK', 'POR'],
  [37362, 'Diogo Costa', 'GK', 'POR'],
  [2000, 'João Cancelo', 'DEF', 'POR'],
  [10183, 'Rúben Dias', 'DEF', 'POR'],
  [15862, 'Nélson Semedo', 'DEF', 'POR'],
  [15905, 'Diogo Dalot', 'DEF', 'POR'],
  [91512, 'Matheus Nunes', 'DEF', 'POR'],
  [144570, 'Nuno Mendes', 'DEF', 'POR'],
  [145357, 'Gonçalo Inácio', 'DEF', 'POR'],
  [177842, 'Tomas Araujo', 'DEF', 'POR'],
  [178769, 'Renato Veiga', 'DEF', 'POR'],
  [3254, 'Bernardo Silva', 'MID', 'POR'],
  [3255, 'Rúben Neves', 'MID', 'POR'],
  [3257, 'Bruno Fernandes', 'MID', 'POR'],
  [3259, 'Gonçalo Guedes', 'MID', 'POR'],
  [140814, 'Samuel Almeida Costa', 'MID', 'POR'],
  [178722, 'Vitinha', 'MID', 'POR'],
  [190877, 'Joao Neves', 'MID', 'POR'],
  [44, 'Cristiano Ronaldo', 'FWD', 'POR'],
  [2074, 'Pedro Neto', 'FWD', 'POR'],
  [15892, 'Rafael Leão', 'FWD', 'POR'],
  [37332, 'Trincão', 'FWD', 'POR'],
  [39265, 'João Félix', 'FWD', 'POR'],
  [101431, 'Gonçalo Ramos', 'FWD', 'POR'],
  [150791, 'Francisco Conceição', 'FWD', 'POR'],
  [48729, 'Keisuke Ōsako', 'GK', 'JPN'],
  [118920, 'Zion Suzuki', 'GK', 'JPN'],
  [161335, 'Tomoki Hayakawa', 'GK', 'JPN'],
  [3264, 'Yūto Nagatomo', 'DEF', 'JPN'],
  [9034, 'Takehiro Tomiyasu', 'DEF', 'JPN'],
  [48657, 'Hiroki Ito', 'DEF', 'JPN'],
  [48670, 'Yukinari Sugawara', 'DEF', 'JPN'],
  [48902, 'Ko Itakura', 'DEF', 'JPN'],
  [49097, 'Shogo Taniguchi', 'DEF', 'JPN'],
  [113230, 'Ayumu Seko', 'DEF', 'JPN'],
  [113595, 'Tsuyoshi Watanabe', 'DEF', 'JPN'],
  [181210, 'Junnosuke Suzuki', 'DEF', 'JPN'],
  [3269, 'Wataru Endō', 'MID', 'JPN'],
  [6716, 'Daichi Kamada', 'MID', 'JPN'],
  [48555, 'Takefusa Kubo', 'MID', 'JPN'],
  [48595, 'Keito Nakamura', 'MID', 'JPN'],
  [49105, 'Ao Tanaka', 'MID', 'JPN'],
  [114809, 'Kaishu Sano', 'MID', 'JPN'],
  [145293, 'Yuito Suzuki', 'MID', 'JPN'],
  [7531, 'Ritsu Doan', 'FWD', 'JPN'],
  [44017, 'Daizen Maeda', 'FWD', 'JPN'],
  [48659, 'Koki Ogawa', 'FWD', 'JPN'],
  [49080, 'Junya Ito', 'FWD', 'JPN'],
  [119460, 'Ayase Ueda', 'FWD', 'JPN'],
  [247160, 'Kento Shiogai', 'FWD', 'JPN'],
  [274204, 'Keisuke Goto', 'FWD', 'JPN'],
  [3285, 'Guillermo Ochoa', 'GK', 'MEX'],
  [39540, 'Carlos Acevedo', 'GK', 'MEX'],
  [177674, 'José Rangel', 'GK', 'MEX'],
  [3298, 'Jesús Gallardo', 'DEF', 'MEX'],
  [39246, 'César Montes', 'DEF', 'MEX'],
  [39330, 'Johan Vásquez', 'DEF', 'MEX'],
  [39546, 'Jorge Sánchez', 'DEF', 'MEX'],
  [84096, 'Israel Reyes', 'DEF', 'MEX'],
  [246145, 'Mateo Chávez', 'DEF', 'MEX'],
  [3293, 'Edson Álvarez', 'MID', 'MEX'],
  [38786, 'Orbelín Pineda', 'MID', 'MEX'],
  [39587, 'Luis Chávez', 'MID', 'MEX'],
  [39927, 'Luis Romo', 'MID', 'MEX'],
  [76356, 'Erik Lira', 'MID', 'MEX'],
  [99992, 'Álvaro Fidalgo', 'MID', 'MEX'],
  [144457, 'Brian Gutiérrez', 'MID', 'MEX'],
  [170442, 'Obed Vargas', 'MID', 'MEX'],
  [264596, 'Gilberto Mora', 'MID', 'MEX'],
  [3305, 'Raúl Jiménez', 'FWD', 'MEX'],
  [39237, 'Julián Quiñones', 'FWD', 'MEX'],
  [39472, 'Roberto Alvarado', 'FWD', 'MEX'],
  [39635, 'Santiago Giménez', 'FWD', 'MEX'],
  [39667, 'Alexis Vega', 'FWD', 'MEX'],
  [39833, 'Guillermo Martínez', 'FWD', 'MEX'],
  [98820, 'César Huerta', 'FWD', 'MEX'],
  [229284, 'Armando González', 'FWD', 'MEX'],
  [3309, 'Jordan Pickford', 'GK', 'ENG'],
  [5457, 'Dean Henderson', 'GK', 'ENG'],
  [153874, 'James Trafford', 'GK', 'ENG'],
  [3313, 'John Stones', 'DEF', 'ENG'],
  [4870, 'Dan Burn', 'DEF', 'ENG'],
  [6317, 'Ezri Konsa', 'DEF', 'ENG'],
  [56628, 'Reece James', 'DEF', 'ENG'],
  [80775, 'Djed Spence', 'DEF', 'ENG'],
  [118489, 'Marc Guéhi', 'DEF', 'ENG'],
  [168712, 'Valentino Livramento', 'DEF', 'ENG'],
  [176718, 'Jarell Quansah', 'DEF', 'ENG'],
  [206743, "Nico O'Reilly", 'DEF', 'ENG'],
  [3320, 'Jordan Henderson', 'MID', 'ENG'],
  [4032, 'Eberechi Eze', 'MID', 'ENG'],
  [7848, 'Anthony Gordon', 'MID', 'ENG'],
  [8215, 'Declan Rice', 'MID', 'ENG'],
  [82140, 'Morgan Rogers', 'MID', 'ENG'],
  [107330, 'Elliot Anderson', 'MID', 'ENG'],
  [125010, 'Jude Bellingham', 'MID', 'ENG'],
  [190797, 'Kobbie Mainoo', 'MID', 'ENG'],
  [3331, 'Marcus Rashford', 'FWD', 'ENG'],
  [4444, 'Ollie Watkins', 'FWD', 'ENG'],
  [5453, 'Ivan Toney', 'FWD', 'ENG'],
  [8004, 'Harry Kane', 'FWD', 'ENG'],
  [99813, 'Bukayo Saka', 'FWD', 'ENG'],
  [167720, 'Noni Madueke', 'FWD', 'ENG'],
  [76936, 'Matt Turner', 'GK', 'USA'],
  [113261, 'Matt Freese', 'GK', 'USA'],
  [167172, 'Chris Brady', 'GK', 'USA'],
  [3927, 'Antonee Robinson', 'DEF', 'USA'],
  [3956, 'Tim Ream', 'DEF', 'USA'],
  [76866, 'Miles Robinson', 'DEF', 'USA'],
  [77185, 'Auston Trusty', 'DEF', 'USA'],
  [77803, 'Mark McKenzie', 'DEF', 'USA'],
  [82442, 'Joseph Scally', 'DEF', 'USA'],
  [97534, 'Sergiño Dest', 'DEF', 'USA'],
  [99856, 'Chris Richards', 'DEF', 'USA'],
  [177823, 'Alex Freeman', 'DEF', 'USA'],
  [6507, 'Weston McKennie', 'MID', 'USA'],
  [39023, 'Alejandro Zendejas', 'MID', 'USA'],
  [77029, 'Cristian Roldan', 'MID', 'USA'],
  [77596, 'Tyler Adams', 'MID', 'USA'],
  [113262, 'Brenden Aaronson', 'MID', 'USA'],
  [136733, 'Gio Reyna', 'MID', 'USA'],
  [140416, 'Sebastian Berhalter', 'MID', 'USA'],
  [144470, 'Malik Tillman', 'MID', 'USA'],
  [145, 'Christian Pulisic', 'FWD', 'USA'],
  [8492, 'Tim Weah', 'FWD', 'USA'],
  [10076, 'Haji Wright', 'FWD', 'USA'],
  [119731, 'Ricardo Pepi', 'FWD', 'USA'],
  [131040, 'Folarin Balogun', 'FWD', 'USA'],
  [192180, 'Max Arfsten', 'FWD', 'USA'],
  [166683, 'Seung-Gyu Kim', 'GK', 'KOR'],
  [189673, 'Bum-keun Song', 'GK', 'KOR'],
  [189775, 'Hyeon-woo Jo', 'GK', 'KOR'],
  [168299, 'Min-Jae Kim', 'DEF', 'KOR'],
  [171221, 'Moon-hwan Kim', 'DEF', 'KOR'],
  [217715, 'Han-bum Lee', 'DEF', 'KOR'],
  [243858, 'Young-woo Seol', 'DEF', 'KOR'],
  [244407, 'Jin-seob Park', 'DEF', 'KOR'],
  [246906, 'Tae-hyeon Kim', 'DEF', 'KOR'],
  [254209, 'Gi-hyuk Lee', 'DEF', 'KOR'],
  [282051, 'Tae-seok Lee', 'DEF', 'KOR'],
  [295846, 'Cho Wi-Je', 'DEF', 'KOR'],
  [151888, 'Jens Castrop', 'MID', 'KOR'],
  [170561, 'In-beom Hwang', 'MID', 'KOR'],
  [177318, 'Dong-gyeong Lee', 'MID', 'KOR'],
  [179889, 'Jae-sung Lee', 'MID', 'KOR'],
  [189741, 'Jin-Gyu Kim', 'MID', 'KOR'],
  [189752, 'Seung-Ho Paik', 'MID', 'KOR'],
  [213217, 'Kang-in Lee', 'MID', 'KOR'],
  [217655, 'Joon-ho Bae', 'MID', 'KOR'],
  [3354, 'Hwang Heechan', 'FWD', 'KOR'],
  [170281, 'Heung-min Son', 'FWD', 'KOR'],
  [189665, 'Hyun-jun Yang', 'FWD', 'KOR'],
  [189762, 'Gue-Sung Cho', 'FWD', 'KOR'],
  [191295, 'Hyun-Gyu Oh', 'FWD', 'KOR'],
  [261683, 'Ji-sung Eom', 'FWD', 'KOR'],
  [8316, 'Brice Samba', 'GK', 'FRA'],
  [8390, 'Mike Maignan', 'GK', 'FRA'],
  [188389, 'Robin Risser', 'GK', 'FRA'],
  [71, 'Theo Hernández', 'DEF', 'FRA'],
  [3359, 'Lucas Digne', 'DEF', 'FRA'],
  [3365, 'Lucas Hernández', 'DEF', 'FRA'],
  [8499, 'Jules Koundé', 'DEF', 'FRA'],
  [9541, 'Dayot Upamecano', 'DEF', 'FRA'],
  [9542, 'Ibrahima Konaté', 'DEF', 'FRA'],
  [80171, 'William Saliba', 'DEF', 'FRA'],
  [82351, 'Maxence Lacroix', 'DEF', 'FRA'],
  [152498, 'Malo Gusto', 'DEF', 'FRA'],
  [3367, "N'Golo Kanté", 'MID', 'FRA'],
  [3368, 'Adrien Rabiot', 'MID', 'FRA'],
  [8514, 'Aurélien Tchouameni', 'MID', 'FRA'],
  [102395, 'Manu Koné', 'MID', 'FRA'],
  [133242, 'Rayan Cherki', 'MID', 'FRA'],
  [175701, 'Maghnes Akliouche', 'MID', 'FRA'],
  [177522, 'Desire Doue', 'MID', 'FRA'],
  [186089, 'Warren Zaïre-Emery', 'MID', 'FRA'],
  [641, 'Jean-Philippe Mateta', 'FWD', 'FRA'],
  [3373, 'Ousmane Dembélé', 'FWD', 'FRA'],
  [3374, 'Kylian Mbappé', 'FWD', 'FRA'],
  [8685, 'Marcus Thuram-Ulien', 'FWD', 'FRA'],
  [113765, 'Michael Olise', 'FWD', 'FRA'],
  [172762, 'Bradley Barcola', 'FWD', 'FRA'],
  [33986, 'Ronwen Williams', 'GK', 'RSA'],
  [34123, 'Sipho Chaine', 'GK', 'RSA'],
  [34456, 'Ricardo Goss', 'GK', 'RSA'],
  [33994, 'Aubrey Modiba', 'DEF', 'RSA'],
  [34481, 'Nkosinathi Sibisi', 'DEF', 'RSA'],
  [74101, 'Khuliso Mudau', 'DEF', 'RSA'],
  [217832, 'Olwethu Makhanya', 'DEF', 'RSA'],
  [245836, 'Bradley Cross', 'DEF', 'RSA'],
  [277223, 'Samukelo Kabini', 'DEF', 'RSA'],
  [279850, 'Ime Okon', 'DEF', 'RSA'],
  [285992, 'Mbekezeli Mbokazi', 'DEF', 'RSA'],
  [286005, 'Khulumani Ndamane', 'DEF', 'RSA'],
  [287754, 'Tholo Matuludi', 'DEF', 'RSA'],
  [33954, 'Themba Zwane', 'MID', 'RSA'],
  [34012, 'Teboho Mokoena', 'MID', 'RSA'],
  [133788, 'Sphephelo Sithole', 'MID', 'RSA'],
  [147928, 'Jayden Adams', 'MID', 'RSA'],
  [245495, 'Thapelo Maseko', 'MID', 'RSA'],
  [277299, 'Thalente Mbatha', 'MID', 'RSA'],
  [286003, 'Kamogelo Sebelebele', 'MID', 'RSA'],
  [34760, 'Lyle Foster', 'FWD', 'RSA'],
  [118915, 'Oswin Appollis', 'FWD', 'RSA'],
  [124636, 'Iqraam Rayners', 'FWD', 'RSA'],
  [245511, 'Evidence Makgopa', 'FWD', 'RSA'],
  [270771, 'Relebohile Mofokeng', 'FWD', 'RSA'],
  [287753, 'Tshepang Moremi', 'FWD', 'RSA'],
  [3871, 'Luca Zidane', 'GK', 'ALG'],
  [130440, 'Oussama Benbout', 'GK', 'ALG'],
  [171469, 'Melvin Mastil', 'GK', 'ALG'],
  [19, 'Aïssa Mandi', 'DEF', 'ALG'],
  [8642, 'Rayan Aït Nouri', 'DEF', 'ALG'],
  [8805, 'Ramy Bensebaini', 'DEF', 'ALG'],
  [116150, 'Samir Chergui', 'DEF', 'ALG'],
  [147891, 'Jaouen Hadjam', 'DEF', 'ALG'],
  [160756, 'Rafik Belghali', 'DEF', 'ALG'],
  [245545, 'Zinédine Belaïd', 'DEF', 'ALG'],
  [245574, 'Amine Tougai', 'DEF', 'ALG'],
  [295347, 'Achref Abada', 'DEF', 'ALG'],
  [6503, 'Nabil Bentaleb', 'MID', 'ALG'],
  [8466, 'Houssem Aouar', 'MID', 'ALG'],
  [123508, 'Hicham Boudaoui', 'MID', 'ALG'],
  [124715, 'Ramiz Zerrouki', 'MID', 'ALG'],
  [178658, 'Fares Chaïbi', 'MID', 'ALG'],
  [202532, 'Ibrahim Maza', 'MID', 'ALG'],
  [261523, 'Yacine Titraoui', 'MID', 'ALG'],
  [293057, 'Adil Boulbina', 'MID', 'ALG'],
  [8069, 'Riyad Mahrez', 'FWD', 'ALG'],
  [8476, 'Amine Gouiri', 'FWD', 'ALG'],
  [180827, 'Mohammed Amoura', 'FWD', 'ALG'],
  [192676, 'Nadhir Benbouali', 'FWD', 'ALG'],
  [244466, 'Anis Moussa', 'FWD', 'ALG'],
  [245324, 'Farés Ghedjemis', 'FWD', 'ALG'],
  [3403, 'Maty Ryan', 'GK', 'AUS'],
  [4697, 'Paul Izzo', 'GK', 'AUS'],
  [177427, 'Patrick Beach', 'GK', 'AUS'],
  [3407, 'Aziz Behich', 'DEF', 'AUS'],
  [3410, 'Miloš Degenek', 'DEF', 'AUS'],
  [4563, 'Kai Trewin', 'DEF', 'AUS'],
  [4795, 'Jacob Italiano', 'DEF', 'AUS'],
  [5432, 'Cameron Burgess', 'DEF', 'AUS'],
  [11636, 'Harry Souttar', 'DEF', 'AUS'],
  [56254, 'Jason Geria', 'DEF', 'AUS'],
  [176299, 'Jordan Bos', 'DEF', 'AUS'],
  [176730, 'Alessandro Circati', 'DEF', 'AUS'],
  [270733, 'Lucas Herrington', 'DEF', 'AUS'],
  [3420, 'Mathew Leckie', 'MID', 'AUS'],
  [3421, 'Jackson Irvine', 'MID', 'AUS'],
  [4635, 'Connor Metcalfe', 'MID', 'AUS'],
  [7528, 'Ajdin Hrustic', 'MID', 'AUS'],
  [8053, "Aiden O'Neill", 'MID', 'AUS'],
  [45143, 'Awer Mabil', 'MID', 'AUS'],
  [76250, 'Cameron Devlin', 'MID', 'AUS'],
  [263718, 'Paul Okon-Engstler', 'MID', 'AUS'],
  [141451, 'Mohamed Toure', 'FWD', 'AUS'],
  [167783, 'Nishan Velupillay', 'FWD', 'AUS'],
  [175891, 'Cristian Volpato', 'FWD', 'AUS'],
  [176991, 'Nestor Irankunda', 'FWD', 'AUS'],
  [181753, 'Tete Yengi', 'FWD', 'AUS'],
  [48418, 'Max Crocombe', 'GK', 'NZL'],
  [80167, 'Michael Woud', 'GK', 'NZL'],
  [176204, 'Alex Paulsen', 'GK', 'NZL'],
  [4690, 'Liberato Cacace', 'DEF', 'NZL'],
  [11392, 'Tommy Smith', 'DEF', 'NZL'],
  [77036, 'Michael Boxall', 'DEF', 'NZL'],
  [111787, 'Francis De Vries', 'DEF', 'NZL'],
  [113754, 'Callan Elliot', 'DEF', 'NZL'],
  [125116, 'Tim Payne', 'DEF', 'NZL'],
  [146549, 'Nando Pijnaker', 'DEF', 'NZL'],
  [176993, 'Finn Surman', 'DEF', 'NZL'],
  [214425, 'Tyler Bindon', 'DEF', 'NZL'],
  [4680, 'Alex Rufer', 'MID', 'NZL'],
  [4684, 'Sarpreet Singh', 'MID', 'NZL'],
  [7723, 'Ryan Thomas', 'MID', 'NZL'],
  [125117, 'Callum McCowatt', 'MID', 'NZL'],
  [144646, 'Joe Bell', 'MID', 'NZL'],
  [156513, 'Marko Stamenic', 'MID', 'NZL'],
  [177602, 'Ben Old', 'MID', 'NZL'],
  [4593, 'Kosta Barbarouses', 'FWD', 'NZL'],
  [8057, 'Chris Wood', 'FWD', 'NZL'],
  [82829, 'Ben Waine', 'FWD', 'NZL'],
  [118981, 'Elijah Just', 'FWD', 'NZL'],
  [185023, 'Matthew Garbett', 'FWD', 'NZL'],
  [218039, 'Lachlan Bayliss', 'FWD', 'NZL'],
  [261259, 'Jesse Randall', 'FWD', 'NZL'],
  [334, 'Gregor Kobel', 'GK', 'SUI'],
  [9534, 'Yvon Mvogo', 'GK', 'SUI'],
  [205190, 'Marvin Keller', 'GK', 'SUI'],
  [143, 'Manuel Akanji', 'DEF', 'SUI'],
  [1745, 'Ricardo Rodriguez', 'DEF', 'SUI'],
  [2114, 'Silvan Widmer', 'DEF', 'SUI'],
  [3475, 'Nico Elvedi', 'DEF', 'SUI'],
  [30823, 'Eray Cömert', 'DEF', 'SUI'],
  [50215, 'Miro Muheim', 'DEF', 'SUI'],
  [169297, 'Aurele Amenda', 'DEF', 'SUI'],
  [176711, 'Luca Jaquez', 'DEF', 'SUI'],
  [1841, 'Remo Freuler', 'MID', 'SUI'],
  [3477, 'Granit Xhaka', 'MID', 'SUI'],
  [6687, 'Denis Zakaria', 'MID', 'SUI'],
  [16265, 'Michel Aebischer', 'MID', 'SUI'],
  [16275, 'Djibril Sow', 'MID', 'SUI'],
  [16281, 'Christian Fassnacht', 'MID', 'SUI'],
  [31913, 'Ruben Vargas', 'MID', 'SUI'],
  [144909, 'Ardon Jasari', 'MID', 'SUI'],
  [152692, 'Fabian Rieder', 'MID', 'SUI'],
  [212309, 'Johan Manzambi', 'MID', 'SUI'],
  [3483, 'Breel Embolo', 'FWD', 'SUI'],
  [16058, 'Noah Okafor', 'FWD', 'SUI'],
  [30780, 'Cédric Itten', 'FWD', 'SUI'],
  [77641, 'Dan Ndoye', 'FWD', 'SUI'],
  [122313, 'Zeki Amdouni', 'FWD', 'SUI'],
  [24545, 'Hernán Galíndez', 'GK', 'ECU'],
  [24881, 'Gonzalo Valle', 'GK', 'ECU'],
  [169139, 'Moisés Ramírez', 'GK', 'ECU'],
  [24673, 'Ángelo Preciado', 'DEF', 'ECU'],
  [24740, 'Félix Torres', 'DEF', 'ECU'],
  [32642, 'Pervis Estupiñán', 'DEF', 'ECU'],
  [114102, 'William Pacho', 'DEF', 'ECU'],
  [114331, 'Jackson Porozo', 'DEF', 'ECU'],
  [125674, 'Piero Hincapié', 'DEF', 'ECU'],
  [178928, 'Joel Ordoñez', 'DEF', 'ECU'],
  [192819, 'Yaimar Medina', 'DEF', 'ECU'],
  [24670, 'Alan Franco', 'MID', 'ECU'],
  [24988, 'Jordy Alcívar', 'MID', 'ECU'],
  [56066, 'Gonzalo Plata', 'MID', 'ECU'],
  [121103, 'Moisés Caicedo', 'MID', 'ECU'],
  [166131, 'Pedro Vite', 'MID', 'ECU'],
  [179174, 'Alan Minda', 'MID', 'ECU'],
  [205684, 'Ray Paez', 'MID', 'ECU'],
  [212692, 'Denil Castillo', 'MID', 'ECU'],
  [24562, 'Jordy Caicedo', 'FWD', 'ECU'],
  [40009, 'Enner Valencia', 'FWD', 'ECU'],
  [98549, 'John Yeboah', 'FWD', 'ECU'],
  [178940, 'Anthony Valencia', 'FWD', 'ECU'],
  [187375, 'Nilson Angulo', 'FWD', 'ECU'],
  [189975, 'Kevin Rodríguez', 'FWD', 'ECU'],
  [215510, 'Jeremy', 'FWD', 'ECU'],
  [3484, 'Kristoffer Nordfeldt', 'GK', 'SWE'],
  [149732, 'Viktor Johansson', 'GK', 'SWE'],
  [180671, 'Jacob Widell Zetterström', 'GK', 'SWE'],
  [3492, 'Victor Nilsson-Lindelöf', 'DEF', 'SWE'],
  [31019, 'Carl Starfelt', 'DEF', 'SWE'],
  [31531, 'Gabriel Gudmundsson', 'DEF', 'SWE'],
  [31560, 'Hjalmar Ekdal', 'DEF', 'SWE'],
  [31926, 'Eric Smith', 'DEF', 'SWE'],
  [145937, 'Daniel Svensson', 'DEF', 'SWE'],
  [166538, 'Gustaf Lagerbielke', 'DEF', 'SWE'],
  [167031, 'Isak Hien', 'DEF', 'SWE'],
  [167409, 'Herman Johansson', 'DEF', 'SWE'],
  [192811, 'Elliot Stroud', 'DEF', 'SWE'],
  [3500, 'Ken Sema', 'MID', 'SWE'],
  [15354, 'Mattias Svanberg', 'MID', 'SWE'],
  [31065, 'Jesper Karlström', 'MID', 'SWE'],
  [145613, 'Yasin Ayari', 'MID', 'SWE'],
  [180627, 'Besfort Zeneli', 'MID', 'SWE'],
  [180673, 'Taha Ali', 'MID', 'SWE'],
  [193622, 'Lucas Bergvall', 'MID', 'SWE'],
  [6486, 'Alexander Isak', 'FWD', 'SWE'],
  [8279, 'Viktor Gyökeres', 'FWD', 'SWE'],
  [24083, 'Gustaf Nilsson', 'FWD', 'SWE'],
  [72511, 'Benjamin Nygren', 'FWD', 'SWE'],
  [111622, 'Alexander Bernhardsson', 'FWD', 'SWE'],
  [166376, 'Anthony Elanga', 'FWD', 'SWE'],
  [120246, 'Jindřich Staněk', 'GK', 'CZE'],
  [136350, 'Matej Kovar', 'GK', 'CZE'],
  [146753, 'Lukáš Horníček', 'GK', 'CZE'],
  [62536, 'Jaroslav Zelený', 'DEF', 'CZE'],
  [62631, 'Vladimir Coufal', 'DEF', 'CZE'],
  [62769, 'Tomáš Holeš', 'DEF', 'CZE'],
  [127813, 'David Zima', 'DEF', 'CZE'],
  [146716, 'David Jurásek', 'DEF', 'CZE'],
  [188239, 'Robin Hranac', 'DEF', 'CZE'],
  [254530, 'Štěpán Chaloupek', 'DEF', 'CZE'],
  [1878, 'Ladislav Krejčí', 'MID', 'CZE'],
  [6556, 'Vladimír Darida', 'MID', 'CZE'],
  [15742, 'Tomáš Souček', 'MID', 'CZE'],
  [62821, 'David Douděra', 'MID', 'CZE'],
  [67970, 'Michal Sadílek', 'MID', 'CZE'],
  [120279, 'Lukáš Provod', 'MID', 'CZE'],
  [121312, 'Pavel Šulc', 'MID', 'CZE'],
  [145322, 'Lukáš Červ', 'MID', 'CZE'],
  [154082, 'Denis Višinský', 'MID', 'CZE'],
  [269966, 'Alexandr Sojka', 'MID', 'CZE'],
  [293648, 'Hugo Sochůrek', 'MID', 'CZE'],
  [1826, 'Patrik Schick', 'FWD', 'CZE'],
  [16396, 'Tomáš Chorý', 'FWD', 'CZE'],
  [62726, 'Jan Kuchta', 'FWD', 'CZE'],
  [99042, 'Adam Hložek', 'FWD', 'CZE'],
  [99752, 'Mojmír Chytil', 'FWD', 'CZE'],
  [3548, 'Dominik Livaković', 'GK', 'CRO'],
  [16577, 'Ivor Pandur', 'GK', 'CRO'],
  [67883, 'Dominik Kotarski', 'GK', 'CRO'],
  [10206, 'Duje Ćaleta-Car', 'DEF', 'CRO'],
  [15110, 'Marin Pongračić', 'DEF', 'CRO'],
  [74268, 'Martin Erlic', 'DEF', 'CRO'],
  [122188, 'Josip Stanišić', 'DEF', 'CRO'],
  [122266, 'Joško Gvardiol', 'DEF', 'CRO'],
  [134835, 'Josip Šutalo', 'DEF', 'CRO'],
  [216835, 'Luka Vušković', 'DEF', 'CRO'],
  [43, 'Luka Modrić', 'MID', 'CRO'],
  [65, 'Mateo Kovačić', 'MID', 'CRO'],
  [3553, 'Mario Pašalić', 'MID', 'CRO'],
  [7843, 'Nikola Vlašić', 'MID', 'CRO'],
  [23135, 'Nikola Moro', 'MID', 'CRO'],
  [23222, 'Kristijan Jakić', 'MID', 'CRO'],
  [82516, 'Luka Sučić', 'MID', 'CRO'],
  [154013, 'Petar Sucic', 'MID', 'CRO'],
  [156912, 'Martin Baturina', 'MID', 'CRO'],
  [216138, 'Toni Fruk', 'MID', 'CRO'],
  [318, 'Andrej Kramarić', 'FWD', 'CRO'],
  [2004, 'Ivan Perišić', 'FWD', 'CRO'],
  [2237, 'Ante Budimir', 'FWD', 'CRO'],
  [56589, 'Petar Musa', 'FWD', 'CRO'],
  [150052, 'Marco Pašalić', 'FWD', 'CRO'],
  [156629, 'Igor Matanovic', 'FWD', 'CRO'],
  [3561, 'Mohammed Al Owais', 'GK', 'KSA'],
  [233580, 'Nawaf Al Aqidi', 'GK', 'KSA'],
  [249787, 'Ahmed Al Kassar', 'GK', 'KSA'],
  [103094, 'Abdulelah Al Amri', 'DEF', 'KSA'],
  [129098, 'Saud Abdulhamid', 'DEF', 'KSA'],
  [132018, 'Ali Lajami', 'DEF', 'KSA'],
  [244368, 'Hassan Al Tambakti', 'DEF', 'KSA'],
  [244552, 'Hassan Kadesh', 'DEF', 'KSA'],
  [253246, 'Moteb Al Harbi', 'DEF', 'KSA'],
  [295325, 'Ali Majrashi', 'DEF', 'KSA'],
  [295850, 'Jehad Thakri', 'DEF', 'KSA'],
  [295852, 'Nawaf Boushal', 'DEF', 'KSA'],
  [3574, 'Salem Al Dawsari', 'MID', 'KSA'],
  [3583, 'Abdullah Al Khaibari', 'MID', 'KSA'],
  [166119, 'Nasser Al Dawsari', 'MID', 'KSA'],
  [189703, 'Ayman Yahya', 'MID', 'KSA'],
  [248781, 'Musab Al Juwayr', 'MID', 'KSA'],
  [248783, 'Mohammed Kanno', 'MID', 'KSA'],
  [295324, 'Ziyad Al-Johani', 'MID', 'KSA'],
  [295849, 'Mohammed Abu Al Shamat', 'MID', 'KSA'],
  [295851, 'Alaa Al Hejji', 'MID', 'KSA'],
  [114373, 'Sultan Mandash', 'FWD', 'KSA'],
  [166114, 'Saleh Al Shehri', 'FWD', 'KSA'],
  [189799, 'Abdullah Al-Hamdan', 'FWD', 'KSA'],
  [244411, 'Khalid Al Ghannam', 'FWD', 'KSA'],
  [249786, 'Firas Al Brikan', 'FWD', 'KSA'],
  [99393, 'Aymen Dahmen', 'GK', 'TUN'],
  [295200, 'Sabri Ben Hessen', 'GK', 'TUN'],
  [295202, 'Abdelmouhib Chamakh', 'GK', 'TUN'],
  [3595, 'Dylan Bronn', 'DEF', 'TUN'],
  [99394, 'Ali El Abdi', 'DEF', 'TUN'],
  [99799, 'Yan Valery', 'DEF', 'TUN'],
  [130471, 'Mortadha Ben Ouanes', 'DEF', 'TUN'],
  [144669, 'Omar Rekik', 'DEF', 'TUN'],
  [173578, 'Yassine Chikhaoui', 'DEF', 'TUN'],
  [177695, 'Montassar Talbi', 'DEF', 'TUN'],
  [189007, 'Moutaz Neffati', 'DEF', 'TUN'],
  [273918, 'Mohamed Amine Ben Hamida', 'DEF', 'TUN'],
  [285769, 'Adem Arous', 'DEF', 'TUN'],
  [3608, 'Ellyes Skhiri', 'MID', 'TUN'],
  [6657, 'Rani Khedira', 'MID', 'TUN'],
  [141826, 'Anis Ben Slimane', 'MID', 'TUN'],
  [161414, 'Ismaël Gharbi', 'MID', 'TUN'],
  [169325, 'Hannibal Mejbri', 'MID', 'TUN'],
  [171368, 'Elias Achouri', 'MID', 'TUN'],
  [172854, 'Hadj Mahmoud', 'MID', 'TUN'],
  [95125, 'Sebastian Tounekti', 'FWD', 'TUN'],
  [97476, 'Firas Chaouat', 'FWD', 'TUN'],
  [171927, 'Elias Saad', 'FWD', 'TUN'],
  [277192, 'Hazem Mastouri', 'FWD', 'TUN'],
  [279116, 'Rayan Elloumi', 'FWD', 'TUN'],
  [295662, 'Khalil Ayari', 'FWD', 'TUN'],
  [16641, 'Mert Günok', 'GK', 'TUR'],
  [29518, 'Altay Bayındır', 'GK', 'TUR'],
  [30283, 'Uğurcan Çakır', 'GK', 'TUR'],
  [9475, 'Çağlar Söyüncü', 'DEF', 'TUR'],
  [9512, 'Kaan Ayhan', 'DEF', 'TUR'],
  [9869, 'Ferdi Kadıoğlu', 'DEF', 'TUR'],
  [10647, 'Mert Müldür', 'DEF', 'TUR'],
  [29622, 'Zeki Çelik', 'DEF', 'TUR'],
  [29804, 'Abdülkerim Bardakcı', 'DEF', 'TUR'],
  [30548, 'Ozan Kabak', 'DEF', 'TUR'],
  [37118, 'Merih Demiral', 'DEF', 'TUR'],
  [127226, 'Samet Akaydın', 'DEF', 'TUR'],
  [145831, 'Evren Eren Elmalı', 'DEF', 'TUR'],
  [201, 'Salih Özcan', 'MID', 'TUR'],
  [1754, 'Hakan Çalhanoğlu', 'MID', 'TUR'],
  [7474, 'Orkun Kökçü', 'MID', 'TUR'],
  [148295, 'İsmail Yüksek', 'MID', 'TUR'],
  [169162, 'Arda Guler', 'MID', 'TUR'],
  [171972, 'Oguz Aydin', 'MID', 'TUR'],
  [172081, 'Baris Yilmaz', 'MID', 'TUR'],
  [180964, 'İrfan Kahveci', 'MID', 'TUR'],
  [79906, 'Yunus Akgün', 'FWD', 'TUR'],
  [149737, 'Muhammed Kerem Aktürkoğlu', 'FWD', 'TUR'],
  [188466, 'Deniz Gul', 'FWD', 'TUR'],
  [191712, 'Kenan Yıldız', 'FWD', 'TUR'],
  [193605, 'Can Uzun', 'FWD', 'TUR'],
  [805, 'Edouard Mendy', 'GK', 'SEN'],
  [8608, 'Yehvann Diouf', 'GK', 'SEN'],
  [20931, 'Mory Diaw', 'GK', 'SEN'],
  [194, 'Ismail Jakobs', 'DEF', 'SEN'],
  [2086, 'Kalidou Koulibaly', 'DEF', 'SEN'],
  [8723, 'Moussa Niakhaté', 'DEF', 'SEN'],
  [38154, 'Abdoulaye Seck', 'DEF', 'SEN'],
  [168667, 'Antoine Mendy', 'DEF', 'SEN'],
  [190866, 'Mamadou Sarr', 'DEF', 'SEN'],
  [205441, 'El Hadji Diouf', 'DEF', 'SEN'],
  [633, 'Pape Gueye', 'MID', 'SEN'],
  [3627, 'Idrissa Gana Guèye', 'MID', 'SEN'],
  [3638, 'Ismaïla Sarr', 'MID', 'SEN'],
  [8887, 'Krépin Diatta', 'MID', 'SEN'],
  [37649, 'Pathé Ciss', 'MID', 'SEN'],
  [94091, 'Iliman Ndiaye', 'MID', 'SEN'],
  [170391, 'Pape Sarr', 'MID', 'SEN'],
  [171876, 'Habib Diarra', 'MID', 'SEN'],
  [204269, 'Lamine Camara', 'MID', 'SEN'],
  [290450, 'Bara Ndiaye', 'MID', 'SEN'],
  [3626, 'Sadio Mané', 'FWD', 'SEN'],
  [9148, 'Cherif Ndiaye', 'FWD', 'SEN'],
  [152515, 'Nicolas Jackson', 'FWD', 'SEN'],
  [166640, 'Ahmadou Bamba Dieng', 'FWD', 'SEN'],
  [218474, 'Assane Diao', 'FWD', 'SEN'],
  [265040, "Ibrahim M'Baye", 'FWD', 'SEN'],
  [252052, 'Pape Thiaw', 'MID', 'SEN'],
  [3641, 'Thibaut Courtois', 'GK', 'BEL'],
  [129946, 'Senne Lammens', 'GK', 'BEL'],
  [191068, 'Mike Penders', 'GK', 'BEL'],
  [1836, 'Timothy Castagne', 'DEF', 'BEL'],
  [3650, 'Thomas Meunier', 'DEF', 'BEL'],
  [8873, 'Brandon Mechele', 'DEF', 'BEL'],
  [142075, 'Maxim De Cuyper', 'DEF', 'BEL'],
  [145893, 'Arthur Theate', 'DEF', 'BEL'],
  [153556, 'Koni De Winter', 'DEF', 'BEL'],
  [160926, 'Zeno Debast', 'DEF', 'BEL'],
  [192677, 'Nathan Ngoy', 'DEF', 'BEL'],
  [213534, 'Joaquin Seys', 'DEF', 'BEL'],
  [3654, 'Kevin De Bruyne', 'MID', 'BEL'],
  [3656, 'Axel Witsel', 'MID', 'BEL'],
  [3658, 'Youri Tielemans', 'MID', 'BEL'],
  [8128, 'Dodi Lukebakio', 'MID', 'BEL'],
  [8858, 'Alexis Saelemaekers', 'MID', 'BEL'],
  [8888, 'Hans Vanaken', 'MID', 'BEL'],
  [8915, 'Nicolas Raskin', 'MID', 'BEL'],
  [99775, 'Jeremy Doku', 'MID', 'BEL'],
  [114024, 'Amadou Onana', 'MID', 'BEL'],
  [182192, 'Diego Moreira', 'MID', 'BEL'],
  [3662, 'Romelu Lukaku', 'FWD', 'BEL'],
  [8984, 'Leandro Trossard', 'FWD', 'BEL'],
  [129947, 'Charles De Ketelaere', 'FWD', 'BEL'],
  [213511, 'Matias Fernandez-Pardo', 'FWD', 'BEL'],
  [3693, 'Munir Mohamedi', 'GK', 'MAR'],
  [3694, 'Yassine Bounou', 'GK', 'MAR'],
  [3695, 'Ahmed Reda Tagnaouti', 'GK', 'MAR'],
  [53, 'Achraf Hakimi', 'DEF', 'MAR'],
  [7553, 'Noussair Mazraoui', 'DEF', 'MAR'],
  [8296, 'Issa Diop', 'DEF', 'MAR'],
  [81191, 'Nayef Aguerd', 'DEF', 'MAR'],
  [137693, 'Anass Salah-Eddine', 'DEF', 'MAR'],
  [150948, 'Chadi Riad', 'DEF', 'MAR'],
  [172822, 'Redouane Halhal', 'DEF', 'MAR'],
  [213459, 'Zakaria El Ouahdi', 'DEF', 'MAR'],
  [277391, 'Youssef Belammari', 'DEF', 'MAR'],
  [3705, 'Sofyan Amrabat', 'MID', 'MAR'],
  [7887, 'Brahim Diaz', 'MID', 'MAR'],
  [122511, 'Azzedine Ounahi', 'MID', 'MAR'],
  [130173, 'Ismael Saibari', 'MID', 'MAR'],
  [170647, 'Neil El Aynaoui', 'MID', 'MAR'],
  [189873, 'Bilal El Khannouss', 'MID', 'MAR'],
  [192313, 'Chemsdine Talbi', 'MID', 'MAR'],
  [221819, 'Ayyoub Bouaddi', 'MID', 'MAR'],
  [244929, 'Samir El Mourabet', 'MID', 'MAR'],
  [130502, 'Soufiane Rahimi', 'FWD', 'MAR'],
  [172417, 'Ayoub El Kaabi', 'FWD', 'MAR'],
  [175941, 'Abdessamad Ezzalzouli', 'FWD', 'MAR'],
  [245336, 'Gessime Yassine', 'FWD', 'MAR'],
  [261438, 'Ayoube Amaimouni-Echghouyab', 'FWD', 'MAR'],
  [10702, 'Alexander Schlager', 'GK', 'AUT'],
  [10837, 'Patrick Pentz', 'GK', 'AUT'],
  [217244, 'Florian Wiegele', 'GK', 'AUT'],
  [349, 'David Alaba', 'DEF', 'AUT'],
  [395, 'Stefan Posch', 'DEF', 'AUT'],
  [6576, 'Philipp Mwene', 'DEF', 'AUT'],
  [6655, 'Kevin Danso', 'DEF', 'AUT'],
  [9447, 'Marco Friedl', 'DEF', 'AUT'],
  [9477, 'Philipp Lienhart', 'DEF', 'AUT'],
  [61968, 'Michael Svoboda', 'DEF', 'AUT'],
  [113457, 'Alexander Prass', 'DEF', 'AUT'],
  [123212, 'David Affengruber', 'DEF', 'AUT'],
  [404, 'Florian Grillitsch', 'MID', 'AUT'],
  [6501, 'Alessandro Schöpf', 'MID', 'AUT'],
  [9549, 'Konrad Laimer', 'MID', 'AUT'],
  [9551, 'Marcel Sabitzer', 'MID', 'AUT'],
  [16344, 'Xaver Schlager', 'MID', 'AUT'],
  [16346, 'Romano Schmid', 'MID', 'AUT'],
  [56829, 'Christoph Baumgartner', 'MID', 'AUT'],
  [113038, 'Nicolas  Seiwald', 'MID', 'AUT'],
  [124324, 'Patrick Wimmer', 'MID', 'AUT'],
  [167570, 'Carney Chukwuemeka', 'MID', 'AUT'],
  [176932, 'Paul Wanner', 'MID', 'AUT'],
  [6661, 'Michael Gregoritsch', 'FWD', 'AUT'],
  [8223, 'Marko Arnautovic', 'FWD', 'AUT'],
  [10761, 'Saša Kalajdžić', 'FWD', 'AUT'],
  [3721, 'Camilo Vargas', 'GK', 'COL'],
  [3722, 'David Ospina', 'GK', 'COL'],
  [22742, 'Álvaro Montero', 'GK', 'COL'],
  [3723, 'Santiago Arias', 'DEF', 'COL'],
  [3724, 'Johan Mojica', 'DEF', 'COL'],
  [3728, 'Yerry Mina', 'DEF', 'COL'],
  [3733, 'Davinson Sánchez', 'DEF', 'COL'],
  [8913, 'Deiver Machado', 'DEF', 'COL'],
  [22010, 'Daniel Muñoz', 'DEF', 'COL'],
  [22113, 'Jhon Lucumí', 'DEF', 'COL'],
  [82825, 'Willer Ditta', 'DEF', 'COL'],
  [365, 'James Rodríguez', 'MID', 'COL'],
  [3737, 'Jefferson Lerma', 'MID', 'COL'],
  [22306, 'Jhon Arias', 'MID', 'COL'],
  [29012, 'Jorge Carrascal', 'MID', 'COL'],
  [156738, 'Kevin Castaño', 'MID', 'COL'],
  [168403, 'Juan Quintero', 'MID', 'COL'],
  [170245, 'Jaminton Campaz', 'MID', 'COL'],
  [170657, 'Richard Rios', 'MID', 'COL'],
  [178353, 'Juan Portilla', 'MID', 'COL'],
  [191421, 'Gustavo Puerta', 'MID', 'COL'],
  [212, 'Jhon Córdoba', 'FWD', 'COL'],
  [22396, 'Luis Díaz', 'FWD', 'COL'],
  [32386, 'Luis Suárez', 'FWD', 'COL'],
  [32415, 'Cucho Hernández', 'FWD', 'COL'],
  [178432, 'Carlos Gómez', 'FWD', 'COL'],
  [3743, 'Mohamed El Shenawy', 'GK', 'EGY'],
  [132128, 'Mohamed Alaa', 'GK', 'EGY'],
  [251169, 'Oufa Shobeir', 'GK', 'EGY'],
  [295344, 'El Mahdi Soliman', 'GK', 'EGY'],
  [780, 'Karim Hafez', 'DEF', 'EGY'],
  [83057, 'Mohamed Hany', 'DEF', 'EGY'],
  [245519, 'Yasser Ibrahim', 'DEF', 'EGY'],
  [245553, 'Ahmed El Fotouh', 'DEF', 'EGY'],
  [245563, 'Mohamed Abdelmonem', 'DEF', 'EGY'],
  [245625, 'Rami Rabia', 'DEF', 'EGY'],
  [261033, 'Hossam Abdelmaguid', 'DEF', 'EGY'],
  [295343, 'Tarek Alaa', 'DEF', 'EGY'],
  [45207, 'Zizo', 'MID', 'EGY'],
  [114669, 'Nabil Dunga', 'MID', 'EGY'],
  [132389, 'Hamdy Fathy', 'MID', 'EGY'],
  [180952, 'Trezeguet', 'MID', 'EGY'],
  [191972, 'Emam Ashour', 'MID', 'EGY'],
  [245550, 'Mohanad Lashin', 'MID', 'EGY'],
  [245582, 'Marwan Attia', 'MID', 'EGY'],
  [261012, 'Mahmoud Saber', 'MID', 'EGY'],
  [295848, 'Mostafa Ziko', 'MID', 'EGY'],
  [3754, 'Mohamed Salah', 'FWD', 'EGY'],
  [66896, 'Omar Marmoush', 'FWD', 'EGY'],
  [98222, 'Haissem Hassan', 'FWD', 'EGY'],
  [253635, 'Ibrahim Adel', 'FWD', 'EGY'],
  [274542, 'Hamza Abdelkarim', 'FWD', 'EGY'],
  [21226, 'Maxime Crépeau', 'GK', 'CAN'],
  [113351, 'Dayne St. Clair', 'GK', 'CAN'],
  [189264, 'Owen Goodman', 'GK', 'CAN'],
  [21288, 'Alphonso Davies', 'DEF', 'CAN'],
  [77691, 'Richie Laryea', 'DEF', 'CAN'],
  [81286, 'Alfie Jones', 'DEF', 'CAN'],
  [112209, 'Joel Waterman', 'DEF', 'CAN'],
  [113228, 'Derek Cornelius', 'DEF', 'CAN'],
  [118604, 'Alistair Johnston', 'DEF', 'CAN'],
  [192153, 'Moise Bombito', 'DEF', 'CAN'],
  [217596, 'Luc De Fougerolles', 'DEF', 'CAN'],
  [21199, 'Jonathan Osorio', 'MID', 'CAN'],
  [37479, 'Stephen Eustáquio', 'MID', 'CAN'],
  [72777, 'Mathieu Choinière', 'MID', 'CAN'],
  [113175, 'Tajon Buchanan', 'MID', 'CAN'],
  [140546, 'Marcelo Flores', 'MID', 'CAN'],
  [171216, 'Nathan-Dylan Saliba', 'MID', 'CAN'],
  [172183, 'Ismael Kone', 'MID', 'CAN'],
  [181976, 'Ali Ahmed', 'MID', 'CAN'],
  [216809, 'Niko Sigur', 'MID', 'CAN'],
  [8924, 'Jonathan David', 'FWD', 'CAN'],
  [15958, 'Cyle Larin', 'FWD', 'CAN'],
  [110807, 'Liam Millar', 'FWD', 'CAN'],
  [111842, 'Jacob Shaffelburg', 'FWD', 'CAN'],
  [177826, 'Tani Oluwaseyi', 'FWD', 'CAN'],
  [260992, 'Promise Akinpelu', 'FWD', 'CAN'],
  [154781, 'Alexandre Pierre', 'GK', 'HAI'],
  [170624, 'Johny Placide', 'GK', 'HAI'],
  [295199, 'Josué Duverger', 'GK', 'HAI'],
  [532, 'Carlens Arcus', 'DEF', 'HAI'],
  [776, 'Jean-Kevin Duverne', 'DEF', 'HAI'],
  [8845, 'Hannes Delcroix', 'DEF', 'HAI'],
  [158228, 'Martin Expérience', 'DEF', 'HAI'],
  [166220, 'Ricardo Adé', 'DEF', 'HAI'],
  [253605, 'Duke LaCroix', 'DEF', 'HAI'],
  [256398, 'Keeto Thermoncy', 'DEF', 'HAI'],
  [291152, 'Wilguens Paugain', 'DEF', 'HAI'],
  [433, 'Leverton Pierre', 'MID', 'HAI'],
  [788, 'Jean-Ricner Bellegarde', 'MID', 'HAI'],
  [77609, 'Derrick Etienne', 'MID', 'HAI'],
  [177049, 'Danley Jean Jacques', 'MID', 'HAI'],
  [182788, 'Dominique Simon', 'MID', 'HAI'],
  [250006, 'Carl Sainté', 'MID', 'HAI'],
  [295197, 'Woodensky Pierre', 'MID', 'HAI'],
  [5380, 'Duckens Nazon', 'FWD', 'HAI'],
  [74870, 'Frantzdy Pierrot', 'FWD', 'HAI'],
  [82421, 'Yassin Fortune', 'FWD', 'HAI'],
  [83599, 'Wilson Isidor', 'FWD', 'HAI'],
  [106726, 'Lenny Joseph', 'FWD', 'HAI'],
  [125787, 'Louicius Don Deedson', 'FWD', 'HAI'],
  [152737, 'Josué Casimir', 'FWD', 'HAI'],
  [152801, 'Ruben Providence', 'FWD', 'HAI'],
  [3797, 'Hossein Hosseini', 'GK', 'IRN'],
  [103099, 'Payam Niazmand', 'GK', 'IRN'],
  [171319, 'Alireza Beiranvand', 'GK', 'IRN'],
  [3800, 'Ehsan Hajsafi', 'DEF', 'IRN'],
  [3804, 'Ramin Rezaeian', 'DEF', 'IRN'],
  [3811, 'Milad Mohammadi', 'DEF', 'IRN'],
  [231884, 'Hossein Kanaanizadegan', 'DEF', 'IRN'],
  [231889, 'Shojae Khalilzadeh', 'DEF', 'IRN'],
  [231900, 'Rouzbeh Cheshmi', 'DEF', 'IRN'],
  [249673, 'Saleh Hardani', 'DEF', 'IRN'],
  [295339, 'Ali Nemati', 'DEF', 'IRN'],
  [295340, 'Danial Eiri', 'DEF', 'IRN'],
  [3821, 'Saeid Ezatolahi', 'MID', 'IRN'],
  [189724, 'Mehdi Torabi', 'MID', 'IRN'],
  [189790, 'Mohammad Ghorbani', 'MID', 'IRN'],
  [244158, 'Ariya Yousefi', 'MID', 'IRN'],
  [249672, 'Medhi Ghayedi', 'MID', 'IRN'],
  [295334, 'Amir Razzaghinia', 'MID', 'IRN'],
  [3819, 'Alireza Jahanbakhsh', 'FWD', 'IRN'],
  [3820, 'Mehdi Taremi', 'FWD', 'IRN'],
  [33634, 'Dennis Eckert', 'FWD', 'IRN'],
  [119530, 'Ali Alipour', 'FWD', 'IRN'],
  [152180, 'Shahriar Moghanlou', 'FWD', 'IRN'],
  [172641, 'Mohammad Mohebi', 'FWD', 'IRN'],
  [179746, 'Saman Ghoddos', 'FWD', 'IRN'],
  [254746, 'Amir Hosseinzadeh', 'FWD', 'IRN'],
  [17645, 'Martin Zlomislić', 'GK', 'BIH'],
  [65105, 'Nikola Vasilj', 'GK', 'BIH'],
  [276572, 'Mladen Jurkas', 'GK', 'BIH'],
  [7786, 'Sead Kolašinac', 'DEF', 'BIH'],
  [15357, 'Dennis Hadžikadunić', 'DEF', 'BIH'],
  [17869, 'Nihad Mujakić', 'DEF', 'BIH'],
  [23182, 'Nikola Katić', 'DEF', 'BIH'],
  [65758, 'Stjepan Radeljić', 'DEF', 'BIH'],
  [81816, 'Amar Dedić', 'DEF', 'BIH'],
  [189153, 'Tarik Muharemović', 'DEF', 'BIH'],
  [216398, 'Nidal Čelik', 'DEF', 'BIH'],
  [9400, 'Dženis Burnić', 'MID', 'BIH'],
  [23206, 'Ivan Šunjić', 'MID', 'BIH'],
  [30102, 'Amir Hadžiahmetović', 'MID', 'BIH'],
  [119385, 'Armin Gigovic', 'MID', 'BIH'],
  [147030, 'Ivan Bašić', 'MID', 'BIH'],
  [189280, 'Benjamin Tahirovic', 'MID', 'BIH'],
  [221764, 'Ermin Mahmic', 'MID', 'BIH'],
  [275052, 'Amar Memić', 'MID', 'BIH'],
  [1822, 'Edin Džeko', 'FWD', 'BIH'],
  [17767, 'Jovo Lukić', 'FWD', 'BIH'],
  [33242, 'Ermedin Demirovic', 'FWD', 'BIH'],
  [63218, 'Haris Tabaković', 'FWD', 'BIH'],
  [172226, 'Samed Bazdar', 'FWD', 'BIH'],
  [186380, 'Esmir Bajraktarevic', 'FWD', 'BIH'],
  [272213, 'Kerim Alajbegović', 'FWD', 'BIH'],
  [28382, 'Luis Mejía', 'GK', 'PAN'],
  [100186, 'Orlando Mosquera', 'GK', 'PAN'],
  [110566, 'Cesar Samudio', 'GK', 'PAN'],
  [22771, 'Roderick Miller', 'DEF', 'PAN'],
  [43786, 'Fidel Escobar', 'DEF', 'PAN'],
  [43787, 'Éric Davis', 'DEF', 'PAN'],
  [76711, 'Andrés Andrade', 'DEF', 'PAN'],
  [84481, 'César Blackman', 'DEF', 'PAN'],
  [100199, 'Jiovany Ramos', 'DEF', 'PAN'],
  [103208, 'José Cordoba', 'DEF', 'PAN'],
  [188908, 'Michael Murillo', 'DEF', 'PAN'],
  [253717, 'Edgardo Fariña', 'DEF', 'PAN'],
  [275040, 'Jorge Gutiérrez', 'DEF', 'PAN'],
  [3864, 'Adalberto Carrasquilla', 'MID', 'PAN'],
  [8919, 'José Luis Rodríguez', 'MID', 'PAN'],
  [28668, 'Cecilio Waterman', 'MID', 'PAN'],
  [39139, 'Édgar Bárcenas', 'MID', 'PAN'],
  [43793, 'Aníbal Godoy', 'MID', 'PAN'],
  [58751, 'Alberto Quintero', 'MID', 'PAN'],
  [103158, 'Carlos Harvey', 'MID', 'PAN'],
  [110577, 'César Yanis', 'MID', 'PAN'],
  [166946, 'Christian Martinez', 'MID', 'PAN'],
  [3868, 'José Fajardo', 'FWD', 'PAN'],
  [43795, 'Ismael Díaz', 'FWD', 'PAN'],
  [105650, 'Tomas Rodriguez', 'FWD', 'PAN'],
  [159094, 'Azarias Londoño', 'FWD', 'PAN'],
  [53172, 'Márcio Rosa', 'GK', 'CPV'],
  [120725, 'Vózinha', 'GK', 'CPV'],
  [150997, 'C.J. dos Santos', 'GK', 'CPV'],
  [593, 'Steven Moreira', 'DEF', 'CPV'],
  [814, 'Logan Costa', 'DEF', 'CPV'],
  [36618, 'Roberto Lopes', 'DEF', 'CPV'],
  [45328, 'Diney Borges', 'DEF', 'CPV'],
  [63097, 'Stopira', 'DEF', 'CPV'],
  [209178, 'Sidny Lopes Cabral', 'DEF', 'CPV'],
  [213136, 'Wagner Pina', 'DEF', 'CPV'],
  [246869, 'Kelvin Pires', 'DEF', 'CPV'],
  [7759, 'Deroy Duarte', 'MID', 'CPV'],
  [30554, 'Garry Rodrigues', 'MID', 'CPV'],
  [40121, 'Kevin Pina', 'MID', 'CPV'],
  [67968, 'Laros Duarte', 'MID', 'CPV'],
  [103108, 'Yannick Semedo', 'MID', 'CPV'],
  [145346, 'Telmo Arcanjo', 'MID', 'CPV'],
  [167455, 'Jamiro Monteiro', 'MID', 'CPV'],
  [212575, 'João Paulo', 'MID', 'CPV'],
  [9278, 'Willy Semedo', 'FWD', 'CPV'],
  [30502, 'Ryan Mendes', 'FWD', 'CPV'],
  [37116, 'Jovane Cabral', 'FWD', 'CPV'],
  [151942, 'Gilson Tavares', 'FWD', 'CPV'],
  [166784, 'Nuno Da Costa', 'FWD', 'CPV'],
  [175919, 'Dailon Rocha Livramento', 'FWD', 'CPV'],
  [213119, 'Hélio Varela', 'FWD', 'CPV'],
  [98898, 'Timothy Fayulu', 'GK', 'COD'],
  [106838, 'Lionel Mpasi', 'GK', 'COD'],
  [170838, 'Matthieu Epolo', 'GK', 'COD'],
  [3894, 'Axel Tuanzebe', 'DEF', 'COD'],
  [7918, 'Chancel Mbemba', 'DEF', 'COD'],
  [8158, 'Aaron Wan-Bissaka', 'DEF', 'COD'],
  [8204, 'Arthur Masuaku', 'DEF', 'COD'],
  [8700, 'Joris Kayembe', 'DEF', 'COD'],
  [9160, 'Dylan Batubinsika', 'DEF', 'COD'],
  [82600, 'Gédéon Kalulu', 'DEF', 'COD'],
  [220602, 'Steve Kapuadi', 'DEF', 'COD'],
  [8596, 'Gaël Kakuta', 'MID', 'COD'],
  [8701, 'Samuel Moutoussamy', 'MID', 'COD'],
  [8854, 'Edo Kayembe', 'MID', 'COD'],
  [14596, 'Aaron Tshibola', 'MID', 'COD'],
  [30876, 'Charles Pickel', 'MID', 'COD'],
  [182273, 'Noah Sadiki', 'MID', 'COD'],
  [192666, "Ngal'ayel Mukau", 'MID', 'COD'],
  [612, 'Yoane Wissa', 'FWD', 'COD'],
  [9309, 'Theo Bongonda', 'FWD', 'COD'],
  [21583, 'Cédric Bakambu', 'FWD', 'COD'],
  [74554, 'Simon Banza', 'FWD', 'COD'],
  [125668, 'Nathanael Mbuku', 'FWD', 'COD'],
  [166776, 'Meschack Elia', 'FWD', 'COD'],
  [243626, 'Brian Cipenga', 'FWD', 'COD'],
  [245577, 'Fiston Mayele', 'FWD', 'COD'],
  [616, 'Yahia Fofana', 'GK', 'CIV'],
  [8292, 'Alban Lafont', 'GK', 'CIV'],
  [170943, 'Mohamed Kone', 'GK', 'CIV'],
  [526, "Evan N'Dicka", 'DEF', 'CIV'],
  [700, 'Christopher Operi', 'DEF', 'CIV'],
  [37432, 'Ghislain Konan', 'DEF', 'CIV'],
  [113375, 'Wilfried Singo', 'DEF', 'CIV'],
  [135473, 'Guela Doué', 'DEF', 'CIV'],
  [149731, 'Emmanuel Agbadou', 'DEF', 'CIV'],
  [167098, 'Odilon Kossounou', 'DEF', 'CIV'],
  [191760, 'Ousmane Diomande', 'DEF', 'CIV'],
  [1747, 'Franck Kessié', 'MID', 'CIV'],
  [2126, 'Seko Fofana', 'MID', 'CIV'],
  [8307, 'Ibrahim Sangaré', 'MID', 'CIV'],
  [8430, 'Jean Michaël Seri', 'MID', 'CIV'],
  [133584, 'Amad Diallo', 'MID', 'CIV'],
  [144698, 'Parfait Guiagon', 'MID', 'CIV'],
  [269161, 'Christ Ravynel Inao Oulaï', 'MID', 'CIV'],
  [8412, 'Nicolas Pépé', 'FWD', 'CIV'],
  [128710, 'Evann Guessand', 'FWD', 'CIV'],
  [152738, 'Ange-Yoan Bonny', 'FWD', 'CIV'],
  [156808, 'Sepe Elye Wahi', 'FWD', 'CIV'],
  [166249, 'Simon Adingra', 'FWD', 'CIV'],
  [188275, 'Oumar Diakite', 'FWD', 'CIV'],
  [249312, 'Bazoumana Touré', 'FWD', 'CIV'],
  [277484, 'Yan Diomandé', 'FWD', 'CIV'],
  [103173, 'Salah Zakaria', 'GK', 'QAT'],
  [129104, 'Meshaal Barsham', 'GK', 'QAT'],
  [156781, 'Mahmoud Abunada', 'GK', 'QAT'],
  [115828, 'Boualem Khoukhi', 'DEF', 'QAT'],
  [189707, 'Jassem Gaber Abdulsallam', 'DEF', 'QAT'],
  [189725, 'Homam Ahmed', 'DEF', 'QAT'],
  [189969, 'Ró-Ró', 'DEF', 'QAT'],
  [194260, 'Lucas Mendes', 'DEF', 'QAT'],
  [249804, 'Sultan Al Brake', 'DEF', 'QAT'],
  [253305, 'Hashemi Al Hussain', 'DEF', 'QAT'],
  [295191, 'Issa Laye', 'DEF', 'QAT'],
  [295196, 'Ayoub Al-Oui', 'DEF', 'QAT'],
  [57667, 'Assim Madibo', 'MID', 'QAT'],
  [115827, 'Abdulaziz Hatem', 'MID', 'QAT'],
  [115829, 'Karim Boudiaf', 'MID', 'QAT'],
  [115832, 'Ahmed Fathy', 'MID', 'QAT'],
  [129107, 'Yusuf Abdurisag', 'MID', 'QAT'],
  [249923, 'Ahmed Al Ganehi', 'MID', 'QAT'],
  [253301, 'Tahsin Jamshid', 'MID', 'QAT'],
  [295195, 'Mohamed Al-Mannai', 'MID', 'QAT'],
  [57652, 'Akram Afif', 'FWD', 'QAT'],
  [115837, 'Almoez Ali', 'FWD', 'QAT'],
  [135684, 'Mohammed Muntari', 'FWD', 'QAT'],
  [189973, 'Hassan Al Haydos', 'FWD', 'QAT'],
  [189976, 'Ahmed Alaa Eldin', 'FWD', 'QAT'],
  [255986, 'Edmílson', 'FWD', 'QAT'],
  [243818, 'Yazeed Abu Layla', 'GK', 'JOR'],
  [249669, 'Abdallah Al Fakhouri', 'GK', 'JOR'],
  [250010, 'Noureddin Bani Ateyah', 'GK', 'JOR'],
  [116915, 'Ehsan Haddad', 'DEF', 'JOR'],
  [116921, 'Saleem Obaid', 'DEF', 'JOR'],
  [119303, 'Yazan Al Arab', 'DEF', 'JOR'],
  [202806, 'Mohammad Abualnadi', 'DEF', 'JOR'],
  [244110, 'Abdallah Naseeb', 'DEF', 'JOR'],
  [249653, 'Saed Al Rosan', 'DEF', 'JOR'],
  [295354, 'Husam Abu Dahab', 'DEF', 'JOR'],
  [295867, 'Anas Badawi', 'DEF', 'JOR'],
  [231890, 'Nizar Al Rashdan', 'MID', 'JOR'],
  [244171, 'Rajaei Ayed', 'MID', 'JOR'],
  [244206, 'Noor Al Rawabdeh', 'MID', 'JOR'],
  [244241, 'Mohammad Abu Hasheesh', 'MID', 'JOR'],
  [249756, 'Ibrahim Saadeh', 'MID', 'JOR'],
  [295351, 'Mohammad Al-Dawoud', 'MID', 'JOR'],
  [295352, 'Amer Jamous', 'MID', 'JOR'],
  [98763, 'Musa Al Taamari', 'FWD', 'JOR'],
  [116928, 'Mahmoud Al Mardi', 'FWD', 'JOR'],
  [244174, 'Ali Olwan', 'FWD', 'JOR'],
  [244346, 'Mohannad Abu Taha', 'FWD', 'JOR'],
  [249762, 'Mohammad Abu Zrayq', 'FWD', 'JOR'],
  [280317, 'Ibrahim Sabra', 'FWD', 'JOR'],
  [295348, 'Odeh Fakhoury', 'FWD', 'JOR'],
  [295350, 'Ali Azaizeh', 'FWD', 'JOR'],
  [117137, 'Jalal Hassan', 'GK', 'IRQ'],
  [132162, 'Fahad Talib', 'GK', 'IRQ'],
  [236206, 'Ahmed Basil', 'GK', 'IRQ'],
  [129968, 'Hussein Ali', 'DEF', 'IRQ'],
  [152724, 'Merchas Doski', 'DEF', 'IRQ'],
  [210821, 'Rebin Sulaka', 'DEF', 'IRQ'],
  [236191, 'Mustafa Saadoun', 'DEF', 'IRQ'],
  [236195, 'Ahmed Yahya', 'DEF', 'IRQ'],
  [236201, 'Frans Putros', 'DEF', 'IRQ'],
  [249839, 'Zaid Tahseen', 'DEF', 'IRQ'],
  [249877, 'Manaf Younis', 'DEF', 'IRQ'],
  [253190, 'Akam Hashem', 'DEF', 'IRQ'],
  [31373, 'Amir Al Ammari', 'MID', 'IRQ'],
  [35515, 'Kevin Yakob', 'MID', 'IRQ'],
  [117481, 'Aimar Sher', 'MID', 'IRQ'],
  [123067, 'Ibrahim Bayesh', 'MID', 'IRQ'],
  [165049, 'Youssef Amyn', 'MID', 'IRQ'],
  [167462, 'Ahmed Qasem', 'MID', 'IRQ'],
  [176642, 'Zidane Iqbal', 'MID', 'IRQ'],
  [295321, 'Zaid Ismail', 'MID', 'IRQ'],
  [117153, 'Aymen Hussein', 'FWD', 'IRQ'],
  [177008, 'Ali Al-Hamadi', 'FWD', 'IRQ'],
  [193630, 'Marko Farji', 'FWD', 'IRQ'],
  [218847, 'Ali Jassim El-Aibi', 'FWD', 'IRQ'],
  [221753, 'Mohanad Ali', 'FWD', 'IRQ'],
  [295189, 'Ali Yousif', 'FWD', 'IRQ'],
  [243911, 'Abduvakhid Nematov', 'GK', 'UZB'],
  [244395, 'Botir Ergashev', 'GK', 'UZB'],
  [244531, 'Utkir Yusupov', 'GK', 'UZB'],
  [132172, 'Rustam Ashurmatov', 'DEF', 'UZB'],
  [132173, 'Umar Eshmurodov', 'DEF', 'UZB'],
  [212868, 'Abdukodir Khusanov', 'DEF', 'UZB'],
  [221787, "Jakhongir O'rozov", 'DEF', 'UZB'],
  [231904, 'Farrukh Sayfiyev', 'DEF', 'UZB'],
  [243825, 'Khodjiakbar Alijonov', 'DEF', 'UZB'],
  [243838, 'Sherzod Nasrullayev', 'DEF', 'UZB'],
  [243928, 'Abdulla Abdullayev', 'DEF', 'UZB'],
  [295345, 'Bekhruz Karimov', 'DEF', 'UZB'],
  [295866, 'Avazbek Ulmasaliev', 'DEF', 'UZB'],
  [49149, 'Dostonbek Xamdamov', 'MID', 'UZB'],
  [117321, 'Otabek Shukurov', 'MID', 'UZB'],
  [119221, 'Oston Urunov', 'MID', 'UZB'],
  [132176, 'Jamshid Iskanderov', 'MID', 'UZB'],
  [149716, 'Akmal Mozgovoy', 'MID', 'UZB'],
  [214531, 'Abbosbek Fayzullaev', 'MID', 'UZB'],
  [232740, 'Azizjon Ganiev', 'MID', 'UZB'],
  [232753, 'Odiljon Hamrobekov', 'MID', 'UZB'],
  [262464, 'Sherzod Esanov', 'MID', 'UZB'],
  [49307, 'Eldor Shomurodov', 'FWD', 'UZB'],
  [117326, 'Jaloliddin Masharipov', 'FWD', 'UZB'],
  [183140, 'Igor Sergeev', 'FWD', 'UZB'],
  [249659, 'Azizbek Amonov', 'FWD', 'UZB'],
  [9923, 'Mark Flekken', 'GK', 'NED'],
  [126870, 'Bart Verbruggen', 'GK', 'NED'],
  [137691, 'Robin Roefs', 'GK', 'NED'],
  [7417, 'Denzel Dumfries', 'DEF', 'NED'],
  [7869, 'Virgil van Dijk', 'DEF', 'NED'],
  [8240, 'Nathan Aké', 'DEF', 'NED'],
  [98566, 'Jan Paul van Hecke', 'DEF', 'NED'],
  [98816, 'Jurrien Timber', 'DEF', 'NED'],
  [131177, 'Mickey van de Ven', 'DEF', 'NED'],
  [189477, 'Jorrel Hato', 'DEF', 'NED'],
  [1848, 'Marten de Roon', 'MID', 'NED'],
  [7457, 'Donyell Malen', 'MID', 'NED'],
  [7559, 'Frenkie de Jong', 'MID', 'NED'],
  [7565, 'Noa Lang', 'MID', 'NED'],
  [7688, 'Guus Til', 'MID', 'NED'],
  [7693, 'Teun Koopmeiners', 'MID', 'NED'],
  [7696, 'Tijjani Reijnders', 'MID', 'NED'],
  [81793, 'Ryan Gravenberch', 'MID', 'NED'],
  [97505, 'Mats Wieffer', 'MID', 'NED'],
  [97536, 'Quinten Timber', 'MID', 'NED'],
  [102193, 'Crysencio Summerville', 'MID', 'NED'],
  [7459, 'Cody Gakpo', 'FWD', 'NED'],
  [7561, 'Justin Kluivert', 'FWD', 'NED'],
  [7697, 'Wout Weghorst', 'FWD', 'NED'],
  [8472, 'Memphis Depay', 'FWD', 'NED'],
  [97535, 'Brian Brobbey', 'FWD', 'NED'],
  [6843, 'Ørjan Nyland', 'GK', 'NOR'],
  [44441, 'Egil Selvik', 'GK', 'NOR'],
  [146024, 'Sander Tangvik', 'GK', 'NOR'],
  [16068, 'Kristoffer Ajer', 'DEF', 'NOR'],
  [16197, 'Torbjørn Heggem', 'DEF', 'NOR'],
  [37913, 'Fredrik Bjørkan', 'DEF', 'NOR'],
  [38548, 'Marcus Pedersen', 'DEF', 'NOR'],
  [44030, 'Julian Ryerson', 'DEF', 'NOR'],
  [44032, 'Leo Østigård', 'DEF', 'NOR'],
  [135036, 'Henrik Falchener', 'DEF', 'NOR'],
  [145159, 'Sondre Langås', 'DEF', 'NOR'],
  [205467, 'David Wolfe', 'DEF', 'NOR'],
  [7421, 'Morten Thorsby', 'MID', 'NOR'],
  [7427, 'Martin Ødegaard', 'MID', 'NOR'],
  [8973, 'Sander Berge', 'MID', 'NOR'],
  [37924, 'Patrick Berg', 'MID', 'NOR'],
  [38088, 'Fredrik Aursnes', 'MID', 'NOR'],
  [44033, 'Kristian Thorstvedt', 'MID', 'NOR'],
  [150589, 'Thelo Aasgaard', 'MID', 'NOR'],
  [169295, 'Antonio Nusa', 'MID', 'NOR'],
  [179716, 'Oscar Bobb', 'MID', 'NOR'],
  [8167, 'Alexander Sørloth', 'FWD', 'NOR'],
  [37916, 'Jens Hauge', 'FWD', 'NOR'],
  [38101, 'Erling Haaland', 'FWD', 'NOR'],
  [157796, 'Andreas Schjelderup', 'FWD', 'NOR'],
  [213269, 'Jørgen Strand Larsen', 'FWD', 'NOR'],
  [3981, 'Angus Gunn', 'GK', 'SCO'],
  [15607, 'Craig Gordon', 'GK', 'SCO'],
  [34960, 'Liam Kelly', 'GK', 'SCO'],
  [3986, 'Grant Hanley', 'DEF', 'SCO'],
  [5769, 'Dominic Hyam', 'DEF', 'SCO'],
  [7868, 'Andrew Robertson', 'DEF', 'SCO'],
  [15615, 'Kieran Tierney', 'DEF', 'SCO'],
  [16070, 'Jack Hendry', 'DEF', 'SCO'],
  [34411, 'Anthony Ralston', 'DEF', 'SCO'],
  [34429, 'John Souttar', 'DEF', 'SCO'],
  [34486, 'Scott McKenna', 'DEF', 'SCO'],
  [101111, 'Aaron Hickey', 'DEF', 'SCO'],
  [138174, 'Nathan Patterson', 'DEF', 'SCO'],
  [7905, 'Scott McTominay', 'MID', 'SCO'],
  [34494, 'Kenny McLean', 'MID', 'SCO'],
  [34495, 'Ryan Christie', 'MID', 'SCO'],
  [34638, 'Lewis Ferguson', 'MID', 'SCO'],
  [34646, 'John McGinn', 'MID', 'SCO'],
  [176789, 'Ben Doak', 'MID', 'SCO'],
  [270697, 'Findlay Curtis', 'MID', 'SCO'],
  [290139, 'Tyler Fletcher', 'MID', 'SCO'],
  [4119, 'Che Adams', 'FWD', 'SCO'],
  [25606, 'George Hirst', 'FWD', 'SCO'],
  [35101, 'Ross Stewart', 'FWD', 'SCO'],
  [35126, 'Lyndon Dykes', 'FWD', 'SCO'],
  [52043, 'Lawrence Shankland', 'FWD', 'SCO'],
  [7412, 'Trevor Doornbusch', 'GK', 'CUW'],
  [7437, 'Eloy Room', 'GK', 'CUW'],
  [171283, 'Tyrick Bodak', 'GK', 'CUW'],
  [7229, 'Roshon van Eijma', 'DEF', 'CUW'],
  [7438, 'Joshua Brenet', 'DEF', 'CUW'],
  [7443, 'Armando Obispo', 'DEF', 'CUW'],
  [7744, 'Sheral Floranus', 'DEF', 'CUW'],
  [9428, 'Riechedly Bazoer', 'DEF', 'CUW'],
  [55417, 'Juriën Gaari', 'DEF', 'CUW'],
  [137697, 'Shurandy Sambo', 'DEF', 'CUW'],
  [149120, "Ar'jany Martha", 'DEF', 'CUW'],
  [166156, 'Livano Comenencia', 'DEF', 'CUW'],
  [177433, 'Deveron Fonville', 'DEF', 'CUW'],
  [191954, 'Tyrese Noslin', 'DEF', 'CUW'],
  [4280, 'Leandro Bacuna', 'MID', 'CUW'],
  [7274, 'Godfried Roemeratoe', 'MID', 'CUW'],
  [7518, 'Juninho Bacuna', 'MID', 'CUW'],
  [53327, 'Kevin Felida', 'MID', 'CUW'],
  [6597, 'Gervane Kastaneer', 'FWD', 'CUW'],
  [7986, 'Kenji Gorré', 'FWD', 'CUW'],
  [8288, 'Jürgen Locadia', 'FWD', 'CUW'],
  [98483, 'Tahith Chong', 'FWD', 'CUW'],
  [137025, 'Sontje Hansen', 'FWD', 'CUW'],
  [149134, 'Jearl Margaritha', 'FWD', 'CUW'],
  [156631, 'Jeremy Antonisse', 'FWD', 'CUW'],
  [190770, 'Brandley Kuwas', 'FWD', 'CUW'],
];

/** Every WC 2026 squad player — the card pool. */
export const WC_SQUADS: readonly WcSquadPlayer[] = RAW.map(([id, name, pos, nat]) => ({
  id,
  name,
  pos,
  nat,
}));

/** Accent-, dot- and case-insensitive name key (NFD strip combining marks). */
function normName(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\./g, '').toLowerCase().trim();
}

/**
 * Resolve a feed display name (optionally scoped to a nation code) to one of our
 * squad players, so a live "star performer" or scorer can open the same profile
 * card. Matches exactly or as "first-initial + surname" ("S. Dest" ↔ "Sergiño
 * Dest"), accent-insensitively. Returns null when we don't carry the player.
 */
export function findSquadPlayer(name: string, nat?: string): WcSquadPlayer | null {
  const pool = nat ? WC_SQUADS.filter((p) => p.nat === nat) : WC_SQUADS;
  const target = normName(name);
  if (!target) return null;
  const exact = pool.find((p) => normName(p.name) === target);
  if (exact) return exact;
  const parts = target.split(/\s+/).filter(Boolean);
  const surname = parts[parts.length - 1] ?? '';
  const initial = parts[0]?.[0] ?? '';
  if (surname.length <= 2) return null;
  return (
    pool.find((p) => {
      const np = normName(p.name).split(/\s+/).filter(Boolean);
      return (np[np.length - 1] ?? '') === surname && (np[0]?.[0] ?? '') === initial;
    }) ?? null
  );
}
